"use strict";
(() => {
  const root = document.querySelector('[data-tw-cartridge]');
  if (!root) return;
  const dialog = document.getElementById('cartridge-figure-dialog');
  const image = dialog.querySelector('#cartridge-zoom-image');
  const caption = dialog.querySelector('#cartridge-zoom-caption');
  const sizeButton = dialog.querySelector('#cartridge-zoom-size');
  const scroll = dialog.querySelector('.zoom-scroll');
  let opener;
  root.querySelectorAll('.figure-zoom').forEach(button => {
    button.addEventListener('click', () => {
      opener = button;
      const source = button.querySelector('img');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      image.width = source.naturalWidth;
      image.height = source.naturalHeight;
      caption.textContent = button.closest('figure').querySelector('figcaption').textContent;
      scroll.dataset.original = 'false';
      sizeButton.textContent = '原寸で見る';
      sizeButton.setAttribute('aria-pressed', 'false');
      dialog.showModal();
      scroll.scrollTop = scroll.scrollLeft = 0;
    });
  });
  sizeButton.addEventListener('click', () => {
    const original = scroll.dataset.original !== 'true';
    scroll.dataset.original = String(original);
    sizeButton.setAttribute('aria-pressed', String(original));
    sizeButton.textContent = original ? '全体を表示' : '原寸で見る';
  });
  dialog.querySelector('#cartridge-zoom-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
  const shareDialog = document.getElementById('cartridge-share-dialog');
  const shareButton = root.querySelector('[data-network="sharethis"]');
  if (shareDialog && shareButton) {
    shareButton.addEventListener('click', () => shareDialog.showModal());
    shareDialog.querySelector('#share-close').addEventListener('click', () => shareDialog.close());
    shareDialog.addEventListener('close', () => shareButton.focus());
    shareDialog.querySelector('#share-copy').addEventListener('click', async () => {
      const field = shareDialog.querySelector('#share-url');
      try {
        await navigator.clipboard.writeText(field.value);
        shareDialog.querySelector('#share-status').textContent = 'URLをコピーしました';
      } catch {
        field.focus(); field.select();
        shareDialog.querySelector('#share-status').textContent = '選択したURLをコピーしてください';
      }
    });
  }
})();

// Existing ShareThis integration, isolated to this article.
(() => {
  const root=document.querySelector('[data-tw-cartridge]');
  if(!root||root.dataset.shareBound)return;
  root.dataset.shareBound='true';
  const footer=root.querySelector('.tw-cartridge-share');
  const widget=footer?.querySelector('.sharethis-inline-share-buttons');
  if(!widget)return;
  const canonical=['https:','','shop.'+'topwing.jp'].join('/')+'/blogs/news/cartridge-tonearm-adjustment';
  widget.dataset.url=canonical;
  if(!document.querySelector('script[src^="https://platform-api.sharethis.com/js/sharethis.js"]')){
    const script=document.createElement('script');script.async=true;
    script.src='https://platform-api.sharethis.com/js/sharethis.js#property=66b03d2a969157001920a62f&product=inline-share-buttons&source=shopify';
    document.head.append(script);
  }
  const labels={twitter:'Xで共有',facebook:'Facebookで共有',sharethis:'その他の方法で共有'};
  const prepare=()=>footer.querySelectorAll('.st-btn[data-network]').forEach(button=>{
    if(!labels[button.dataset.network])return;
    button.tabIndex=0;button.setAttribute('role','button');button.setAttribute('aria-label',labels[button.dataset.network]);
  });
  new MutationObserver(prepare).observe(footer,{childList:true,subtree:true});prepare();
  const init=()=>{
    if(!window.__sharethis__?.load)return false;
    widget.id='tw-cartridge-share-buttons';widget.dataset.url=canonical;
    window.__sharethis__.load('inline-share-buttons',{id:widget.id,alignment:'center',enabled:true,font_size:12,padding:10,radius:4,networks:['twitter','facebook','sharethis'],size:40,spacing:8,labels:'cta',language:'ja',show_total:false,min_count:0,url:canonical,title:widget.dataset.title});
    return true;
  };
  if(!init()){let tries=0;const timer=setInterval(()=>{if(init()||++tries>=100)clearInterval(timer)},200);}
  footer.addEventListener('keydown',event=>{
    const button=event.target.closest('.st-btn[data-network]');
    if(button&&footer.contains(button)&&(event.key==='Enter'||event.key===' ')){event.preventDefault();button.click();}
  });
  let opener;
  const restore=()=>{if(opener){const button=opener;opener=null;button.focus({preventScroll:true});setTimeout(()=>button.isConnected&&button.focus({preventScroll:true}),350);}};
  footer.addEventListener('click',event=>{
    const button=event.target.closest('.st-btn[data-network="sharethis"]');if(!button)return;opener=button;
    requestAnimationFrame(()=>{const close=document.querySelector('.st-close');if(close){close.tabIndex=0;close.setAttribute('role','button');close.setAttribute('aria-label','共有メニューを閉じる');}});
  });
  document.addEventListener('keydown',event=>{
    const close=document.querySelector('.st-close');
    if(!opener||!close||!close.getBoundingClientRect().width)return;
    if(event.key==='Escape'||(event.target===close&&(event.key==='Enter'||event.key===' '))){event.preventDefault();close.click();restore();}
  });
  document.addEventListener('click',event=>{if(opener&&event.target.closest('.st-close'))restore();});
})();
